import { useCallback, useContext } from 'react'
import { MapContext } from '../mapContext'

export const useCustomLabel = () => {
  const mapContext = useContext(MapContext)
  if (!mapContext) {
    throw new Error('Custom label must be used within a GoogleMaps map')
  }
  const { map, google: googleMaps } = mapContext

  const createCustomLabel = useCallback(() => {
    if (!map || !googleMaps) {
      return
    }

    return class CustomLabel extends google.maps.OverlayView {
      private position: google.maps.LatLngLiteral
      private text: string
      private div: HTMLDivElement | null

      constructor(position: google.maps.LatLngLiteral, text: string) {
        super()
        this.position = position
        this.text = text
        this.div = null
      }

      onAdd() {
        const div = document.createElement('div')
        div.style.position = 'absolute'
        div.style.fontSize = '16px'
        div.style.color = '#fff'
        div.style.zIndex = '100'
        div.style.transform = 'translate(-50%, -50%)'
        div.innerHTML = this.text

        this.div = div

        const panes = this.getPanes()
        panes?.overlayLayer.appendChild(div)
      }

      draw() {
        if (!this.div) return

        const overlayProjection = this.getProjection()
        const position = overlayProjection?.fromLatLngToDivPixel(
          new google.maps.LatLng(this.position),
        )

        if (position) {
          this.div.style.left = `${position.x}px`
          this.div.style.top = `${position.y}px`
        }
      }

      onRemove() {
        if (this.div) {
          this.div.parentNode?.removeChild(this.div)
          this.div = null
        }
      }
    }
  }, [map, googleMaps])

  return { createCustomLabel }
}
